import { Drawer, theme } from "antd";
import { useEffect, useState } from "react";
import { useOrg } from "src/hooks/useOrg";
import {
  entityContext,
  useEntity,
} from "pages/[orgId]/entity/[entityId]/entity/useEntityContext";
import { EntityDomain } from "pages/[orgId]/entity/[entityId]/entity/EntityDomain";
import { SearchContext } from "../useSearchContext";
import { TopNav } from "pages/[orgId]/entity/[entityId]/entity/components/TopNav";
import { BottomNav } from "pages/[orgId]/entity/[entityId]/entity/components/BottomNav";

export function EntityPreview({
  context,
}: {
  context: Pick<SearchContext, "entity">;
}) {
  const { entity } = context;
  const { token } = theme.useToken();
  const { id: orgId } = useOrg();
  const [uuid, setUuid] = useState<string | undefined>(entity.uuid);
  const [entityList, setEntityList] = useState<string[] | undefined>(
    entity.list
  );
  const [entityIndex, setEntityIndex] = useState<number | undefined>(0);
  useEffect(() => {
    setUuid(entity.uuid);
    setEntityList(entity.list);
    setEntityIndex(entity.list?.indexOf(entity.uuid || ""));
  }, [entity.uuid, entity.list]);
  if (!uuid || !orgId) return null;
  return (
    <Drawer
      key={uuid}
      open={Boolean(uuid)}
      onClose={entity.close}
      width={"80%"}
      style={{
        minWidth: "400px",
        borderBottomLeftRadius: token.borderRadiusLG,
        borderTopLeftRadius: token.borderRadiusLG,
      }}
      zIndex={200}
      headerStyle={{ padding: 10 }}
      bodyStyle={{ padding: 0 }}
      closeIcon={false}
    >
      <EntityPreviewProvider
        orgId={orgId}
        entityUuid={uuid}
        openEntity={setUuid}
        close={entity.close}
        entityList={entityList}
        entityIndex={entityIndex}
        useHistory={true} //to make sure we stay in the drawer
      />
    </Drawer>
  );
}

function EntityPreviewProvider(props: {
  orgId: string;
  entityUuid: string;
  openEntity: (uuid: string | undefined) => void;
  close: () => void;
  entityList?: string[];
  entityIndex?: number;
  useHistory?: boolean;
}) {
  const { token } = theme.useToken();
  const contextValue = useEntity(props);
  return (
    <entityContext.Provider value={contextValue}>
      <div
        style={{
          height: "100%",
          width: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <TopNav close={props.close} />
        <div
          style={{
            flex: 1,
            maxHeight: "100%",
            overflow: "auto",
            paddingLeft: 8,
            borderBottom: `solid 1px ${token.colorBgBase}`,
            borderTop: `solid 1px ${token.colorBgBase}`,
          }}
        >
          <EntityDomain square openEntity={props.openEntity} />
        </div>
        <BottomNav />
      </div>
    </entityContext.Provider>
  );
}
